import React from 'react';

import Img from '../../../Img';
import AddPhotoV3 from './AddPhotoV3';

import styles from '../headerV3.scss';

const AvatarV3 = (props) => {
    const {
        firstName,
        lastName,
        isOwnProfile,
        profileImage,
        handleUploadPhoto,
        handleUploadPhotoPhotoStart,
        handleRemoveProfilePhoto,
        'data-testid': dataTestId,
    } = props;

    return (
        <div className={`${styles.pictureContainer}`} data-testid={dataTestId}>
            {profileImage ? (
                <Img
                    src={`/v1/player/${profileImage}`}
                    data-testid={dataTestId ? `${dataTestId}.image` : undefined}
                />
            ) : (
                <div className={styles.initials} data-testid={dataTestId ? `${dataTestId}.initials` : undefined}>{firstName?.[0]}{lastName?.[0]}</div>
            )}
            {isOwnProfile && (
                <AddPhotoV3
                    uploadPhoto={handleUploadPhoto}
                    uploadStart={handleUploadPhotoPhotoStart}
                    removePhoto={handleRemoveProfilePhoto}
                    hasProfileImage={!!profileImage}
                    data-testid={dataTestId ? `${dataTestId}.add-photo` : undefined}
                />
            )}
        </div>
    );
};

export default AvatarV3;
